import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { cardSurface, Eyebrow } from './page-primitives';
import { MONO_FONT } from '../default/theme';
/**
 * Bordered card of rows separated by hairlines (details previews, token lists,
 * the extension general grid, …). The card owns the row separators, so rows
 * don't draw their own borders.
 */
// eslint-disable-next-line react-refresh/only-export-components
export const DetailsCard = styled(Box)(({ theme }) => ({
    ...cardSurface(theme),
    overflow: 'hidden',
    '& > *': { borderBottom: `1px solid ${theme.palette.border2}` },
    '& > *:last-child': { borderBottom: 0 }
}));
/** Label/value row inside a {@link DetailsCard}. */
export const DetailRow = ({ label, mono, noWrap, empty, children }) => (_jsxs(Box, { sx: { display: 'flex', p: '0.875rem 1.125rem' }, children: [_jsx(Typography, { component: 'span', sx: { width: '8.125rem', flexShrink: 0, fontSize: '0.8125rem', color: 'text.disabled' }, children: label }), _jsx(Typography, { component: 'span', noWrap: noWrap, sx: {
                fontSize: '0.875rem',
                fontWeight: empty ? 400 : 600,
                color: empty ? 'text.disabled' : undefined,
                minWidth: 0,
                overflowWrap: noWrap ? undefined : 'anywhere',
                fontFamily: mono ? MONO_FONT : undefined
            }, children: children })] }));
/** Slim uppercase heading inside a {@link DetailsCard}, splitting the rows below it into a named group. */
export const DetailsGroupLabel = ({ children }) => (_jsx(Eyebrow, { sx: { fontSize: '0.6875rem', fontWeight: 700, color: 'text.secondary', p: '0.4375rem 0.8rem' }, children: children }));
//# sourceMappingURL=details-card.js.map